import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { finalizeMediaUtil, initializeMediaUtil, uploadOnS3 } from "../../../utils/mediaUtils";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import { getKey } from "../../../api/api.keys";
import { CreateAlbum } from "../../../api/api.service";
import { APP_ROUTES } from "../../../helpers/routeHelpers";
import { showToast, SUCCESS } from "../../../utils/toastUtils";
import OnboardingForm from "./OnboardingForm";

const AddOnboarding = () => {
    const history = useHistory();
    let { useMutate } = useRequestProcessor();
    const [isMediaUpload, setIsMediaUpload] = useState(false);
    let { mutate, isLoading } = useMutate("", getKey(), (data) => CreateAlbum(data));

    // media upload on server
    const handleMediaUpload = async (file, initFile) => {
        return initializeMediaUtil(file).then(async (res) => {
            const credentials = res;
            try {
                await uploadOnS3(initFile, credentials);
            } catch (err) {}

            return await finalizeMediaUtil(credentials?.mediaId);
        });
    };

    const addAudioHandler = async (values) => {
        try {
            setIsMediaUpload(true);
            const uploadResults = await Promise.all(
                Object.keys(values).map(async (fieldName) => {
                    const fieldData = values[fieldName];
                    if (fieldData?.file) {
                        const mediaId = await handleMediaUpload(
                            fieldData.file,
                            fieldData?.exactFile
                        );
                        return { fieldName, mediaId };
                    }
                    return null;
                })
            );

            // Attach mediaIds to form values
            uploadResults.forEach((result) => {
                if (result) {
                    const { fieldName, mediaId } = result;
                    values[fieldName].mediaId = mediaId;
                }
            });

            const bodyData = {
                title: values.title,
                description: values.description,
                authorId: Number(values.author?.value), // Convert to number
                categoryId: 5,
                narratorId: Number(values.narrator?.value), // Convert to number
                thumbnailId: Number(values.uploadImage?.mediaId?.id), // Convert to number
                croppedThumbnailId: Number(values.uploadThumbnail?.mediaId?.id), // Convert to number

                audios: [
                    {
                        title: values.title,
                        description: values.description,
                        duration: Math.floor(Number(values.sessionUploadAudio?.file?.duration)), // Convert to number
                        audioMediaId: Number(values.sessionUploadAudio?.mediaId?.id), // Convert to number
                        completionMessage: values.sessionCompletionmessage
                    }
                ]
            };

            mutate(bodyData, {
                onSuccess: async (res) => {
                    showToast(SUCCESS, "Onboarding Audio Created Successfully!");
                    history.push(APP_ROUTES.AUDIO_CONTENT_MANAGEMENT_ONBOARDING);
                    setIsMediaUpload(false);
                },
                onError: (err) => {
                    setIsMediaUpload(false);
                }
            });
        } catch (error) {
            console.error("Error during form submission:", error);
            setIsMediaUpload(false);
        }
    };

    return (
        <OnboardingForm
            mode="add"
            isLoading={isLoading || isMediaUpload}
            isDisabled={isMediaUpload}
            onAddAudio={addAudioHandler}
        />
    );
};

export default AddOnboarding;
